const componentLoaders = {
    FieldGroup: () => require('./FieldGroup'),
    PreferencesGroup: () => require('./PreferencesGroup'),
    ProfilePhotoGroup: () => require('./ProfilePhotoGroup')
};

const internals = {};

internals.isReactComponentObject = (Component) => !!Component
    && typeof Component === 'object'
    && !!Component.$$typeof;

internals.isRenderableComponent = (Component) => typeof Component === 'function'
    || internals.isReactComponentObject(Component);

internals.defineLazyComponent = (target, name, loadComponent) => {

    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        get() {
            const Component = loadComponent();

            Object.defineProperty(target, name, {
                configurable: true,
                enumerable: true,
                value: Component
            });

            return Component;
        }
    });
};

internals.buildLazyComponents = (loaders = componentLoaders) => Object.entries(loaders)
    .reduce((collector, [name, loadComponent]) => {

        internals.defineLazyComponent(collector, name, loadComponent);
        return collector;
    }, {});

const componentsByName = internals.buildLazyComponents();

exports.componentsByName = componentsByName;
exports.componentNames = Object.freeze(Object.keys(componentLoaders));
exports.componentLoaders = componentLoaders;
exports.preloadComponents = () => {

    exports.componentNames.forEach((componentName) => componentsByName[componentName]);
    return componentsByName;
};

exports.buildRegistry = ({ components = {} } = {}) => {
    const registryComponentsByName = internals.buildLazyComponents();

    Object.assign(registryComponentsByName, components);

    return {
        componentsByName: registryComponentsByName
    };
};

exports.resolveGroupComponent = ({
    component,
    type,
    components,
    registry
} = {}) => {

    const componentRef = type || component;

    if (!componentRef) {
        return null;
    }

    if (internals.isRenderableComponent(componentRef)) {
        return componentRef;
    }

    const resolvedComponentsByName = registry?.componentsByName
        || exports.buildRegistry({ components }).componentsByName;

    return resolvedComponentsByName[componentRef] || null;
};

exports.internals = internals;
